module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.canViewStep) ? _c('div', {
    staticClass: "assignment-step"
  }, [_c('div', {
    staticClass: "page-content"
  }, [(_vm.shouldRetake && !_vm.isInspectingStudent) ? _c('div', {
    staticClass: "note note--warning note--large"
  }, [_vm._m(0), _vm._m(1), _c('primary-button', {
    staticClass: "primary-button--no-margin",
    attrs: {
      "link": {
        name: 'assignment.step',
        params: {
          stepIdx: 1
        }
      }
    }
  }, [_vm._v("Begin opdracht")])], 1) : _vm._e(), (_vm.hasDiligence) ? _c('div', {
    staticClass: "note note--info note--large"
  }, [_c('diligence', {
    attrs: {
      "progress": _vm.progress,
      "readonly": true
    }
  })], 1) : _vm._e(), _c('h1', {
    staticClass: "banner"
  }, [(!_vm.isInspectingStudent) ? _c('span', [_vm._v("Dit heb jij gemaakt")]) : _c('span', [_vm._v("Dit heeft " + _vm._s(_vm.user.firstname) + " gemaakt")])]), _vm._l((_vm.regularInputPartials), function(partial) {
    return _c(partial.type, {
      key: partial.id,
      tag: "component",
      attrs: {
        "submissions": partial.submissions,
        "title": partial.title,
        "showVersions": true
      }
    })
  }), (_vm.isInspectingStudent && _vm.reflectingInputPartials.length) ? [_c('h1', {
    staticClass: "banner"
  }, [_c('span', [_vm._v("Feedback van " + _vm._s(_vm.user.firstname))])]), _vm._l((_vm.reflectingInputPartials), function(partial) {
    return _c(partial.type, {
      key: partial.id,
      tag: "component",
      attrs: {
        "submissions": partial.submissions,
        "title": partial.title,
        "showVersions": true
      }
    })
  }), (_vm.reflectionPartials.length) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showReflection(_vm.reflectionPartials[0], _vm.progress)
      }
    }
  }, [_vm._v("Bekijk het werk waar " + _vm._s(_vm.user.firstname) + " feedback op heeft gegeven")]) : _vm._e()] : _vm._e(), (_vm.reflections || _vm.hasFeedback) ? _c('h1', {
    staticClass: "banner"
  }, [(!_vm.isInspectingStudent) ? _c('span', [_vm._v("Feedback")]) : _c('span', [_vm._v("Feedback voor " + _vm._s(_vm.user.firstname))])]) : _vm._e(), _vm._l((_vm.reflections), function(reflection) {
    return _c('div', {
      staticClass: "reflection"
    }, [_c('h1', [_c('small', [_vm._v("Van:")]), _vm._v(" " + _vm._s(_vm.userForReflection(reflection).firstname))]), _c('h2', [_vm._v(_vm._s(_vm.title(_vm.partialForReflection(reflection))))]), _c('p', {
      staticClass: "preformatted"
    }, [_vm._v(_vm._s(reflection.data))])])
  }), (_vm.hasFeedback) ? _c('teacher-feedback', {
    attrs: {
      "feedback": _vm.feedback
    }
  }) : _vm._e(), (!_vm.isInspectingStudent) ? _c('group-submissions', {
    attrs: {
      "assignment": _vm.assignment,
      "group": _vm.group
    }
  }) : _vm._e()], 2), _c('nav', {
    staticClass: "action-nav"
  }, [_c('hr', {
    staticClass: "flipped"
  }), _c('router-link', {
    staticClass: "tag button-timid button-backward",
    attrs: {
      "to": {
        name: 'assignment.step',
        params: {
          stepIdx: _vm.assignment.steps.length
        }
      }
    }
  }, [_vm._v("Vorige stap")]), (!_vm.isInspectingStudent) ? _c('primary-button', {
    staticClass: "action-nav__next",
    attrs: {
      "link": _vm.returnLink.route
    }
  }, [_vm._v("Klaar")]) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('h2', [_c('span', {
    staticClass: "icon icon--inline icon--retake-dark"
  }), _vm._v(" Opnieuw inleveren")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('p', [_vm._v("\n            Je moet deze opdracht opnieuw inleveren door de stappen nog een keer te doorlopen. Je hiervoor ingeleverde werk blijft zichtbaar.\n            "), _c('strong', [_vm._v("Let goed op de feedback die je hebt gekregen!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-851760f4","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/StepOverview.vue
// module id = 5qiO
// module chunks = 1